import React from "react";

import { NumberInput } from "@common/numberInput";
import { AllocationUnit } from "@common/allocationUnit";
import { Props } from "./types";
import styles from "./styles.scss";

function AllocatedHours({ allocatedHours, readOnly, submit }: Props) {
  const [nextAllocatedHours, setNextAllocatedHours] =
    React.useState(allocatedHours);

  React.useEffect(() => {
    setNextAllocatedHours(allocatedHours);
  }, [allocatedHours]);

  return readOnly ? (
    <div className={styles.allocatedHours}>
      <p className={styles.text}>
        {nextAllocatedHours}
        <AllocationUnit />
      </p>
    </div>
  ) : (
    <form
      className={styles.allocatedHours}
      onSubmit={(e) => {
        e.preventDefault();

        nextAllocatedHours !== allocatedHours && submit(nextAllocatedHours);
      }}
      noValidate
    >
      <NumberInput
        className={styles.input}
        value={nextAllocatedHours}
        input={(hours, isValid) =>
          isValid && hours >= 0 && setNextAllocatedHours(hours)
        }
        blur={() =>
          nextAllocatedHours !== allocatedHours && submit(nextAllocatedHours)
        }
      />
      <p className={styles.text}>
        <AllocationUnit />
      </p>
    </form>
  );
}

export { AllocatedHours };
